export const white = '#FFFFFF';
